<template>
    <!--单店活动-->

    <v-touch v-on:swipeleft="swiperleft" v-on:swiperight="swiperright">

        <div class="brt-map-shopActive" ref="shopActive">

            <div class="wrap-box" @click="selete">
                <div class="t-box">

                    <i class="iconfont icon-close-02" @click="close"></i>
                    <p class="title">{{seletedAtive.title}}</p>

                    <p>
                        <img :src="seletedAtive.logo" v-if="seletedAtive.logo">
                        <span v-if="seletedAtive.NAME">{{seletedAtive.NAME}}</span>
                        <span v-if="seletedAtive.FLOOR_NAME">{{seletedAtive.FLOOR_NAME}}</span>
                        <span v-if="seletedAtive.distant">距您 {{seletedAtive.distant}} 米</span>
                    </p>

                </div>

                <div class="slide-box">

                    <!--不采用-->
                    <!--<Swipe class="brt-map-qsm-swipe" :options="swipeOptions" v-if="seletedAtive.slidIMGS">-->

                    <!--<SwipeSlide class="brt-map-qsm-slide" v-for="(item,index) in seletedAtive.slidIMGS">-->

                    <!--<div class="IMG-box" ref="sildeControl"><img :src="item" alt="滑动图片" @click = 'selete(item)'></div>-->

                    <!--</SwipeSlide>-->

                    <!--</Swipe>-->

                    <div class="IMG-box" ref="sildeControl"><img :src="seletedAtive.slidIMGS[0]"></div>

<!--                    <div class="bar-box">-->

<!--                        <div class="l-box">-->
<!--                            <div class="label" v-for="(item,index) in seletedAtive.tags" v-if="index < 3">-->
<!--                                &lt;!&ndash;<i class="rail"></i>&ndash;&gt;-->
<!--                                {{item.name}}-->
<!--                            </div>-->
<!--                        </div>-->

<!--                        <div class="r-box">-->

<!--                            <label v-if="seletedAtive.status == 1">即将进行</label>-->
<!--                            <label v-else-if="seletedAtive.status == 0">进行中</label>-->
<!--                            <label class="end" v-else>已结束</label>-->

<!--                        </div>-->

<!--                    </div>-->


                </div>
            </div>

            <div class="back" @click="close">
                <i class="iconfont icon-left-01"></i>
            </div>
        </div>
    </v-touch>

</template>

<script>

    // import { Swipe, SwipeSlide } from '@/components/swipe'
    // let _data = {
    //     title:'万象彩妆课堂约会装——秒变冬万象彩妆课堂约会装——秒变冬万象彩妆课堂约会装——秒变冬',
    //     logo:'./images/poi_logo.png',
    //     NAME:'戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店',
    //     distant:100,
    //     slidIMGS:['./images/active.png','./images/active.png','./images/active.png'],
    //
    //     tags:[
    //         {
    //         name:'满额即减',
    //         content:'满2000减200'
    //         },
    //         {
    //             name:'抵扣券',
    //             content:'抵扣券499'
    //         },
    //         {
    //             name:'到店赠礼品',
    //             content:'到店赠礼品'
    //         }],
    //
    //     state:0     //0即将开始 1进行中 2已结束
    // }


    export default {
        name: "ShopActiveModule",
        data(){
            return {
                seletedAtive:'',

                // swipeOptions: {
                //     continuous: false,
                //     disableScroll: true,
                //     disableIOSScroll: true,
                //     callback: (i) => {
                //         this.swipeIndex = i;
                //     }
                // },
                //
                // swipeIndex: 0,

            }
        },

        created(){
            let active = this.$BRT.$active.shopPoint.active;

            if(active){

                let logo = active.logo,
                    distant = active.distant,
                    name = active.NAME;

                if(!logo && active.Data.poi.detail && active.Data.poi.detail.LOGO){
                    logo = active.Data.poi.detail.LOGO;
                    active.logo = logo;
                }

                if(!distant && active.Data.poi.detail && active.Data.poi.distance){
                    distant = active.Data.poi.distance;
                    active.distant = distant;
                }

                if(active.Data.poi.NAME){
                    name = active.Data.poi.NAME;
                    active.NAME = name;
                }

                if(active.Data.poi.FLOOR_NAME){
                    active.FLOOR_NAME = active.Data.poi.FLOOR_NAME
                }


                this.seletedAtive = active;

            }

        },

        // components:{
        //     Swipe,
        //     SwipeSlide
        // },

        methods:{

            selete(){
                this.$store.state.ACTIVITY_DATA_DETEIL = this.seletedAtive.Data;
                this.$router.replace('/details/1/'+this.seletedAtive.Data.id);

                this.$BRT.$active.enterActiveDetail = 2;
            },

            close(){

                event.stopPropagation();
                this.$BRT.$active.shopPoint='';
                for(let k=0;k<$VAR.shopMakers.length;k++){$VAR.shopMakers[k].maker.removeClass('active');}
                $VAR.map.easeTo({
                    zoom:$VAR.map.getBaseZoom(),
                    center:$VAR.map.getCenter()
                })

            },

            //滑动处理
            swiper(count){

                for( let i=0;i<$VAR.shopMakers.length;i++){

                    if(this.$BRT.$active.shopPoint.poi.POI_ID == $VAR.shopMakers[i].active.poi.POI_ID){

                        if($VAR.shopMakers[i+count]){

                            for(let k=0;k<$VAR.shopMakers.length;k++){$VAR.shopMakers[k].maker.removeClass('active');}
                            this.$BRT.$active.shopPoint = $VAR.shopMakers[i+count].active;
                            $VAR.shopMakers[i + count].maker.addClass('active');

                            let lngLat = $VAR.map.coordsToLnglat(this.$BRT.$active.shopPoint.poi.LABEL_X,this.$BRT.$active.shopPoint.poi.LABEL_Y);
                            $VAR.map.easeTo({
                                center:lngLat
                            });
                            return;

                        }else{
                            if(count > 0){

                                this.$message.info('暂无数据,往右滑动试试');

                            }else{
                                this.$message.info('暂无数据,往左滑动试试');

                            }


                        }

                    }
                }

            },

            swiperleft(){
                // console.log('向左滑动');
                this.swiper(-1)
            },

            swiperright(){
                // console.log('向右滑动');
                this.swiper(1)
            }
        },

        watch:{
            shopData(v1,v2){

                if(v1){
                    let active = v1.active;

                    if(active){

                        let logo = active.logo,
                            distant = active.distant,
                            name = active.NAME;

                        if(!logo && active.Data.poi.detail && active.Data.poi.detail.LOGO){
                            logo = active.Data.poi.detail.LOGO;
                            active.logo = logo;
                        }

                        if(!distant && active.Data.poi.detail && active.Data.poi.distance){
                            distant = active.Data.poi.distance;
                            active.distant = distant;
                        }

                        if(active.Data.poi.NAME){
                            name = active.Data.poi.NAME;
                            active.NAME = name;
                        }

                        if(active.Data.poi.FLOOR_NAME){
                            active.FLOOR_NAME = active.Data.poi.FLOOR_NAME
                        }

                        this.seletedAtive = active;
                    }
                    else{
                        this.seletedAtive = '';
                    }
                }
                else{
                    this.seletedAtive = '';
                }

            }
        },

        computed:{
            shopData(){
                return this.$BRT.$active.shopPoint;
            }
        }
    }
</script>

<style lang="less">

    @import "ShopActiveModule.less";

</style>
